// import React, { useEffect, useState } from "react";
// import { Modal, Button, Form } from "react-bootstrap";
// import NoDataFound from "../../CommonComponents/NoDataFound";
// import { useMember, useMemberDataPagination } from "../../API_Master/FetchAPI";
// import PageEntries from "../../CommonComponents/PageEntries";
// import PaginationButtons from "../../CommonComponents/PaginationButtons";
// import TableShimmer from "../../Components/TableShimmer";
// import PageCountSelect from "../../CommonComponents/PageCountSelect";
// import Loader from "../../CommonComponents/Loader";
// import { useSetExistingVoter } from "../../API_Master/MutateAPI";
// import { notifyError, notifySuccess } from "../../MethodMaster/JSXComponentMothod";

// const AddExistingVoter = ({ show, handleClose, selectedVillage, selectedLocality, selectedRecords, setSelectedRecords, refetchMemberList, familyHeadMasterID }) => {
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [currentPage, setCurrentPage] = useState(0);
//   const [isSelectAll, setIsSelectAll] = useState(false);
//   //   const [selectedRecords, setSelectedRecords] = useState({});
//   const [searchTerm, setSearchTerm] = useState("");
//   const [tableData, setTableData] = useState([]);

//   console.log("sdfadslkfjdaskfjasklfsa", selectedRecords);

//   const { data: MemberData = [], isFetching: isMemberFetching } = useMember(isSelectAll, selectedVillage, selectedLocality);
//   const { data, fetchNextPage, hasNextPage, isFetching, isLoading, isError, refetch } = useMemberDataPagination(rowsPerPage, "", selectedVillage, selectedLocality);
//   const { mutate: addExistingVoter, isPending: inserting } = useSetExistingVoter();

//   useEffect(() => {
//     if (isSelectAll && MemberData?.length > 0) {
//       setSelectedRecords((prev) => {
//         if (Object.keys(prev).length === MemberData.length) return prev;
//         return MemberData.reduce((acc, ele) => {
//           acc[ele?.VoterID] = ele;
//           return acc;
//         }, {});
//       });
//       setIsSelectAll(false);
//     }
//   }, [isSelectAll, MemberData]);

//   const pages = data?.pages || [];
//   const totalCount = data?.pages[0]?.TotalCount || 0;
//   const currentItems = data?.pages[currentPage]?.data || [];
//   const start = currentPage * rowsPerPage + 1;
//   const end = Math.min(start + currentItems.length - 1, totalCount);

//   useEffect(() => {
//     const filtered = currentItems?.filter((member) => member?.FullNameEnglish?.toLowerCase()?.includes(searchTerm?.toLowerCase()));
//     console.log("filteredData", filtered);
//     setTableData(filtered || []);
//   }, [data, searchTerm]);

//   const handleRowsChange = async (e) => {
//     const limit = parseInt(e.target?.value);
//     setRowsPerPage(limit);
//     setCurrentPage(0);
//     await refetch();
//   };

//   const goToPage = async (index) => {
//     if (pages[index]) setCurrentPage(index);
//     else if (hasNextPage) {
//       await fetchNextPage();
//       setCurrentPage(index);
//     }
//   };

//   const handleCheckboxChange = (id, checked, item) => {
//     if (checked) {
//       const { [id]: removed, ...updated } = selectedRecords;
//       setSelectedRecords(updated);
//     } else {
//       setSelectedRecords((prev) => ({ ...prev, [id]: item }));
//     }
//   };

//   const isAllSelected = tableData.length > 0 && tableData.every((ele) => Object.keys(selectedRecords).includes(ele?.VoterID));

//   console.log("tableDataAndSelectAllFiteredData", selectedRecords, tableData);

//   const handleSelectAll = () => {
//     if (isAllSelected) {
//       const tableVoterIDs = tableData.map((ele) => ele?.VoterID);
//       const updatedRecords = Object.fromEntries(Object.entries(selectedRecords).filter(([key]) => !tableVoterIDs.includes(key)));
//       setSelectedRecords(updatedRecords);
//     } else setIsSelectAll(true);
//   };

//   let filteredData = currentItems?.filter((member) => member?.FullNameEnglish?.toLowerCase()?.includes(searchTerm?.toLowerCase()));

//   const handleHandicapChange = (index) => {
//     setTableData((prev) => prev.map((row, i) => (i === index ? { ...row, Handicap: !row.Handicap } : row)));
//   };

//   const handleOutsideChange = (index) => {
//     setTableData((prev) => prev.map((row, i) => (i === index ? { ...row, Outside: !row.Outside } : row)));
//   };

//   const handleSubmit = () => {
//     const familyDetailData = Object.keys(selectedRecords)?.map((id) => tableData?.find((ele) => ele?.VoterID === id));

//     const payload = {
//       UserID: 1,
//       FamilyHeadMasterID: familyHeadMasterID,
//       FamilyDetail: familyDetailData,
//     };

//     addExistingVoter(payload, {
//       onSuccess: (res) => {
//         if (res?.status === true) {
//           notifySuccess("Successfully Inserted", false);
//           handleClose();
//           refetchMemberList();
//         } else {
//           notifyError(res?.message ? res.message : "Data Not Inserted", false);
//         }
//       },
//       onError: (err) => {
//         const errorMessage = err?.response?.data?.message || "Failed to assign system";
//         console.error(err);
//         notifyError(errorMessage || "Something went wrong", false);
//       },
//     });
//   };

//   return (
//     <>
//       <Modal show={show} onHide={handleClose} centered size="xl" backdrop="static" keyboard={false} className="rounded-4" dialogClassName="custom-modal-width">
//         <Modal.Header closeButton className="border-0 pb-0">
//           <Modal.Title className="fw-bold">Add Existing Voter</Modal.Title>
//         </Modal.Header>

//         <div className="d-flex justify-content-between align-items-center mt-3 px-4 gap-2">
//           <PageCountSelect rowsPerPage={rowsPerPage} handleRowsChange={handleRowsChange} />
//           <Form.Control type="text" placeholder="Search by name..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} style={{ width: "220px" }} />
//           <Button variant="primary" onClick={handleSubmit}>
//             Submit
//           </Button>
//         </div>

//         <Modal.Body className="pt-2">
//           {isFetching || isLoading || isError ? (
//             <TableShimmer theme="light" />
//           ) : (
//             <div
//               className="table-responsive"
//               style={{
//                 borderRadius: "6px",
//                 border: "1px solid #dee2e6",
//               }}
//             >
//               <table className="table table-hover align-middle text-nowrap mb-0">
//                 <thead className="table-light sticky-top">
//                   <tr>
//                     <th className="text-center" style={{ width: "5%" }}>
//                       <input
//                         id="mergeSelectAll"
//                         className="form-check-input cursor-pointer border border-gray"
//                         type="checkbox"
//                         checked={isAllSelected}
//                         onChange={() => handleSelectAll()}
//                       />
//                     </th>
//                     <th style={{ width: "9%" }}>Full Name</th>
//                     <th style={{ width: "8%" }}>Mobile No.</th>
//                     <th style={{ width: "8%" }}>ID Card No.</th>
//                     <th style={{ width: "8%" }}>House No.</th>
//                     <th style={{ width: "10%" }}>Handicap</th>
//                     <th style={{ width: "10%" }}>Outside</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {tableData?.length ? (
//                     tableData.map((Member, idx) => (
//                       <tr key={idx}>
//                         <td className="text-center">
//                           <input
//                             className="form-check-input cursor-pointer border border-gray"
//                             type="checkbox"
//                             checked={Object.keys(selectedRecords).includes(Member?.VoterID)}
//                             onChange={() => handleCheckboxChange(Member?.VoterID, Object.keys(selectedRecords).includes(Member?.VoterID), Member)}
//                           />
//                         </td>
//                         {/* <td>{Member?.BoothName || ""}</td> */}
//                         <td>{Member?.FullNameEnglish || ""}</td>
//                         <td>{Member?.MobileNo || ""}</td>
//                         {/* <td>{Member?.PinCode || ""}</td>
//                         <td>{Member?.SLNo || ""}</td> */}
//                         <td>{Member?.IDCardNo || ""}</td>
//                         {/* <td>{Member?.Gender || ""}</td>
//                         <td>{Member?.Age || ""}</td> */}
//                         <td>{Member?.HouseNoEnglish || ""}</td>
//                         {/* <td>{Member?.PartNameEnglish || ""}</td>
//                         <td>{Member?.LocalityEnglish || ""}</td> */}
//                         <td>
//                           <input className="handicap-checkbox" type="checkbox" checked={Member.Handicap || false} onChange={() => handleHandicapChange(idx)} />
//                         </td>
//                         <td>
//                           <input className="outside-checkbox" type="checkbox" checked={Member.Outside || false} onChange={() => handleOutsideChange(idx)} />
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <NoDataFound colSpan={13} />
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </Modal.Body>

//         <Modal.Footer className="d-flex justify-content-between align-items-center border-0 pt-0">
//           <PageEntries start={start} end={end} totalCount={totalCount} />
//           <PaginationButtons currentPage={currentPage} setCurrentPage={setCurrentPage} goToPage={goToPage} pages={pages} hasNextPage={hasNextPage} fetchNextPage={fetchNextPage} />
//         </Modal.Footer>
//       </Modal>

//       {(isMemberFetching || inserting) && <Loader />}
//     </>
//   );
// };

// export default AddExistingVoter;

// import * as React from "react";
// import { styled } from "@mui/material/styles";
// import {
//   Modal,
//   Box,
//   IconButton,
//   Typography,
//   Table,
//   TableBody,
//   TableCell,
//   tableCellClasses,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Checkbox,
//   TablePagination,
//   TextField,
//   TableSortLabel,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   CircularProgress,
//   Fade,
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import { useMember } from "../../API_Master/FetchAPI";
// import TableShimmer from "../../Components/TableShimmer";

// // --- Styled Components ---
// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//   "&:nth-of-type(odd)": {
//     backgroundColor: theme.palette.action.hover,
//   },
//   "&:hover": {
//     backgroundColor: "#E3F2FD",
//   },
// }));

// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   [`&.${tableCellClasses.head}`]: {
//     backgroundColor: "#D6E4FF",
//     color: "#1A237E",
//     fontWeight: 600,
//     fontSize: 14,
//   },
//   [`&.${tableCellClasses.body}`]: {
//     fontSize: 13,
//   },
// }));

// // --- Main Component ---
// const AddExistingVoter = ({ show, handleClose, selectedRecords, setSelectedRecords, selectedVillage, selectedLocality }) => {
//   const [page, setPage] = React.useState(0);
//   const [rowsPerPage, setRowsPerPage] = React.useState(10);
//   const [searchText, setSearchText] = React.useState("");
//   const [orderBy, setOrderBy] = React.useState("");
//   const [order, setOrder] = React.useState("asc");

//   const { data = [], isFetching: isMemberFetching } = useMember(true, selectedVillage, selectedLocality);

//   React.useEffect(() => setPage(0), [searchText]);

//   const filteredData = React.useMemo(() => {
//     if (!searchText) return data;
//     const lowerSearch = searchText.toLowerCase();
//     return data.filter((row) => Object.values(row).some((val) => val && String(val).toLowerCase().includes(lowerSearch)));
//   }, [data, searchText]);

//   const sortedData = React.useMemo(() => {
//     if (!orderBy) return filteredData;
//     return [...filteredData].sort((a, b) => {
//       const aVal = a[orderBy] || "";
//       const bVal = b[orderBy] || "";
//       if (aVal < bVal) return order === "asc" ? -1 : 1;
//       if (aVal > bVal) return order === "asc" ? 1 : -1;
//       return 0;
//     });
//   }, [filteredData, orderBy, order]);

//   const currentPageData = React.useMemo(() => {
//     const start = page * rowsPerPage;
//     return sortedData.slice(start, start + rowsPerPage);
//   }, [sortedData, page, rowsPerPage]);

//   const isAllSelected = currentPageData.length > 0 && currentPageData.every((r) => Object.keys(selectedRecords).includes(String(r.VoterID)));

//   const handleRowSelect = (voterId, record, checked) => {
//     setSelectedRecords((prev) => {
//       const updated = { ...prev };
//       if (checked) updated[voterId] = record;
//       else delete updated[voterId];
//       return updated;
//     });
//   };

//   const handleSelectAll = () => {
//     setSelectedRecords((prev) => {
//       const updated = { ...prev };
//       if (isAllSelected) {
//         currentPageData.forEach((r) => delete updated[r.VoterID]);
//       } else {
//         currentPageData.forEach((r) => (updated[r.VoterID] = r));
//       }
//       return updated;
//     });
//   };

//   const handleChangePage = (_, newPage) => setPage(newPage);
//   const handleChangeRowsPerPage = (e) => {
//     setRowsPerPage(parseInt(e.target.value, 10));
//     setPage(0);
//   };

//   const handleRequestSort = (columnId) => {
//     const isAsc = orderBy === columnId && order === "asc";
//     setOrder(isAsc ? "desc" : "asc");
//     setOrderBy(columnId);
//   };

//   const columns = [
//     { id: "PartNameEnglish", label: "Booth Name", width: "8%" },
//     { id: "FullNameEnglish", label: "Full Name", width: "9%" },
//     { id: "MobileNo", label: "Mobile No.", width: "8%" },
//     { id: "PinCode", label: "PinCode", width: "8%" },
//     { id: "VoterID", label: "SL No.", width: "8%" },
//     { id: "IDCardNo", label: "ID Card No.", width: "8%" },
//     { id: "Gender", label: "Gender", width: "8%" },
//     { id: "Age", label: "Age", width: "8%" },
//     { id: "HouseNoEnglish", label: "House No.", width: "8%" },
//     { id: "VillageEnglish", label: "Village", width: "10%" },
//     { id: "LocalityEnglish", label: "Locality", width: "10%" },
//   ];

//   return (
//     <Modal
//       open={show}
//       onClose={handleClose}
//       closeAfterTransition
//       aria-labelledby="add-existing-voter-modal"
//       sx={{
//         backdropFilter: "blur(4px)",
//       }}
//     >
//       <Fade in={show}>
//         <Box
//           sx={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             width: "90%",
//             maxWidth: "1200px",
//             bgcolor: "background.paper",
//             borderRadius: 2,
//             boxShadow: 24,
//             p: 2,
//             maxHeight: "90vh",
//             display: "flex",
//             flexDirection: "column",
//           }}
//         >
//           {/* --- Header --- */}
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               mb: 1,
//             }}
//           >
//             <Typography variant="h6" sx={{ fontWeight: 600 }}>
//               Add Existing Voter
//             </Typography>
//             <IconButton onClick={handleClose}>
//               <CloseIcon />
//             </IconButton>
//           </Box>

//           {/* --- Search & Filter Row --- */}
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               mb: 1,
//               flexWrap: "wrap",
//               gap: 2,
//             }}
//           >
//             <FormControl size="small" sx={{ minWidth: 150 }}>
//               <InputLabel>Rows per page</InputLabel>
//               <Select value={rowsPerPage} label="Rows per page" onChange={handleChangeRowsPerPage}>
//                 {[5, 10, 25, 50].map((n) => (
//                   <MenuItem key={n} value={n}>
//                     {n}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             <TextField label="Search" variant="outlined" size="small" value={searchText} onChange={(e) => setSearchText(e.target.value)} sx={{ width: 220 }} />
//           </Box>

//           {/* --- Table Section --- */}
//           <Box sx={{ flex: 1, overflow: "auto" }}>
//             <TableContainer component={Paper} variant="outlined">
//               <Table sx={{ minWidth: 1100 }} aria-label="voter table">
//                 <TableHead>
//                   <TableRow>
//                     <StyledTableCell align="center" padding="checkbox">
//                       <Checkbox color="primary" checked={isAllSelected} onChange={handleSelectAll} />
//                     </StyledTableCell>
//                     {columns.map((col) => (
//                       <StyledTableCell key={col.id} style={{ width: col.width }} sortDirection={orderBy === col.id ? order : false}>
//                         <TableSortLabel active={orderBy === col.id} direction={orderBy === col.id ? order : "asc"} onClick={() => handleRequestSort(col.id)}>
//                           {col.label}
//                         </TableSortLabel>
//                       </StyledTableCell>
//                     ))}
//                   </TableRow>
//                 </TableHead>

//                 <TableBody>
//                   {isMemberFetching ? (
//                     // <TableRow>
//                     //   <StyledTableCell colSpan={columns.length + 1} align="center">
//                     //     <CircularProgress size={24} />
//                     //   </StyledTableCell>
//                     // </TableRow>
//                     <StyledTableCell colSpan={columns.length + 1} align="center">
//                     <TableShimmer theme={"light"} /></StyledTableCell>
//                   ) : currentPageData.length > 0 ? (
//                     currentPageData.map((row) => {
//                       const isChecked = Object.keys(selectedRecords).includes(String(row.VoterID));
//                       return (
//                         <StyledTableRow key={row.VoterID}>
//                           <StyledTableCell align="center" padding="checkbox">
//                             <Checkbox color="primary" checked={isChecked} onChange={(e) => handleRowSelect(row.VoterID, row, e.target.checked)} />
//                           </StyledTableCell>
//                           {columns.map((col) => (
//                             <StyledTableCell key={col.id}>{row[col.id] || "-"}</StyledTableCell>
//                           ))}
//                         </StyledTableRow>
//                       );
//                     })
//                   ) : (
//                     <TableRow>
//                       <StyledTableCell colSpan={columns.length + 1} align="center">
//                         No records found
//                       </StyledTableCell>
//                     </TableRow>
//                   )}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           </Box>

//           {/* --- Pagination --- */}
//           <TablePagination component="div" count={filteredData.length} rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage} rowsPerPageOptions={[]} />
//         </Box>
//       </Fade>
//     </Modal>
//   );
// };

// export default AddExistingVoter;

// import * as React from "react";
// import {
//   Modal,
//   Fade,
//   Box,
//   Paper,
//   Checkbox,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   TableContainer,
//   TablePagination,
//   TableSortLabel,
//   TextField,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Typography,
//   IconButton,
//   FormControlLabel,
//   Checkbox as MuiCheckbox,
// } from "@mui/material";
// import { styled } from "@mui/material/styles";
// import CloseIcon from "@mui/icons-material/Close";
// import { useMember } from "../../API_Master/FetchAPI";
// import TableShimmer from "../../Components/TableShimmer";
// import { notifyError, notifySuccess } from "../../MethodMaster/JSXComponentMothod";
// import { useSetExistingVoter } from "../../API_Master/MutateAPI";
// import { Button } from "react-bootstrap";
// import Loader from "../../CommonComponents/Loader";
// import { object } from "yup";
// import Cookies from "js-cookie";

// // --- Styled Components ---
// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//   "&:nth-of-type(odd)": {
//     backgroundColor: theme.palette.action.hover,
//   },
//   "&:last-child td, &:last-child th": {
//     border: 0,
//   },
//   "&:hover": {
//     backgroundColor: "#E3F2FD",
//   },
// }));

// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   [`&.${theme?.tableCellClasses?.head}`]: {
//     backgroundColor: "#D6E4FF",
//     color: "#1A237E",
//     fontWeight: 600,
//     fontSize: 14,
//   },
//   [`&.${theme?.tableCellClasses?.body}`]: {
//     fontSize: 13,
//   },
// }));

// const AddExistingVoter = ({ show, handleClose, selectedRecords, setSelectedRecords, selectedVillage, selectedLocality, familyHeadMasterID, refetchMemberList }) => {
//   const [page, setPage] = React.useState(0);
//   const [rowsPerPage, setRowsPerPage] = React.useState(10);
//   const [searchText, setSearchText] = React.useState("");
//   const [orderBy, setOrderBy] = React.useState("");
//   const [order, setOrder] = React.useState("asc");
//   const [data, setData] = React.useState([]);
//   const [fetchAllVillage, setFetchAllVillage] = React.useState(false);

//   const { data: MemberData = [], isFetching: isMemberFetching } = useMember(show, selectedVillage, !fetchAllVillage ? selectedLocality : "");
//   const { mutate: addExistingVoter, isPending: inserting } = useSetExistingVoter();

//   React.useEffect(() => setPage(0), [searchText]);

//   React.useEffect(() => {
//     setData(MemberData);
//   }, [MemberData?.length]);

//   // --- Filter + Sort + Paginate ---
//   const filteredData = React.useMemo(() => {
//     if (!searchText) return data;
//     const lower = searchText.toLowerCase();
//     return data.filter((r) => Object.values(r).some((v) => v && String(v).toLowerCase().includes(lower)));
//   }, [data, searchText]);

//   const sortedData = React.useMemo(() => {
//     if (!orderBy) return filteredData;
//     return [...filteredData].sort((a, b) => {
//       const aVal = a[orderBy] || "";
//       const bVal = b[orderBy] || "";
//       return order === "asc" ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
//     });
//   }, [filteredData, orderBy, order]);

//   const currentPageData = React.useMemo(() => {
//     const start = page * rowsPerPage;
//     return sortedData.slice(start, start + rowsPerPage);
//   }, [sortedData, page, rowsPerPage]);

//   // --- Selection logic ---
//   const isAllSelected = currentPageData.length > 0 && currentPageData.every((r) => Object.keys(selectedRecords).includes(String(r.VoterID)));

//   const handleRowSelect = (voterId, record, checked) => {
//     setSelectedRecords((prev) => {
//       const updated = { ...prev };
//       if (checked) updated[voterId] = { ...record };
//       else delete updated[voterId];
//       return updated;
//     });
//   };

//   const handleSelectAll = () => {
//     setSelectedRecords((prev) => {
//       const updated = { ...prev };
//       if (isAllSelected) {
//         currentPageData.forEach((r) => delete updated[r.VoterID]);
//       } else {
//         currentPageData.forEach((r) => (updated[r.VoterID] = { ...r }));
//       }
//       return updated;
//     });
//   };

//   const handleHandicapChange = (voterId) => {
//     setSelectedRecords((prev) => {
//       if (!prev[voterId]) return prev; // only modify selected rows
//       return {
//         ...prev,
//         [voterId]: { ...prev[voterId], IsHandicap: !prev[voterId].IsHandicap },
//       };
//     });
//   };

//   const handleOutsideChange = (voterId) => {
//     console.log("voterIDsdfsdfsdfasdf", voterId);
//     setSelectedRecords((prev) => {
//       if (!prev[voterId]) return prev; // only modify selected rows
//       return {
//         ...prev,
//         [voterId]: { ...prev[voterId], IsOutSide: !prev[voterId].IsOutSide },
//       };
//     });
//   };

//   // const handleHandicapChange = (index) => {
//   //   setData((prev) => prev.map((row, i) => (i === index ? { ...row, Handicap: !row.Handicap } : row)));
//   // };

//   // const handleOutsideChange = (index) => {
//   //   setData((prev) => prev.map((row, i) => (i === index ? { ...row, Outside: !row.Outside } : row)));
//   // };

//   const handleChangePage = (_, newPage) => setPage(newPage);
//   const handleChangeRowsPerPage = (e) => {
//     setRowsPerPage(parseInt(e.target.value, 10));
//     setPage(0);
//   };

//   const handleRequestSort = (columnId) => {
//     const isAsc = orderBy === columnId && order === "asc";
//     setOrder(isAsc ? "desc" : "asc");
//     setOrderBy(columnId);
//   };

//   const columns = [
//     { id: "FullNameEnglish", label: "Full Name", width: "15%" },
//     { id: "MobileNo", label: "Mobile No.", width: "10%" },
//     { id: "IDCardNo", label: "ID Card No.", width: "10%" },
//     { id: "Age", label: "Age", width: "5%" },
//     { id: "HouseNoEnglish", label: "House No.", width: "10%" },
//   ];

//   console.log("checkingthevalueofdata", data, selectedRecords);

//   const handleSubmit = () => {
//     if (Object.keys(selectedRecords)?.length === 0) {
//       notifyError("Please Select at least on Voter");
//       return;
//     }
//     const familyDetailData = Object.keys(selectedRecords)?.map((id) => selectedRecords[id]);

//     console.log("familyDetailData", familyDetailData);

//     const payload = {
//       UserID: Cookies.get("Mukesh_Patel_UserID") || "",
//       FamilyHeadMasterID: familyHeadMasterID,
//       FamilyDetail: familyDetailData,
//       CreatedByUserID: Cookies.get("Mukesh_Patel_UserID") || "",
//     };

//     addExistingVoter(payload, {
//       onSuccess: (res) => {
//         if (res?.status === true) {
//           notifySuccess("Successfully Inserted", false);
//           handleClose();
//           refetchMemberList();
//         } else {
//           notifyError(res?.message ? res.message : "Data Not Inserted", false);
//         }
//       },
//       onError: (err) => {
//         const errorMessage = err?.message || "Failed to assign system";
//         console.error(err);
//         notifyError(errorMessage || "Something went wrong", false);
//       },
//     });
//   };
//   return (
//     <>
//       <Modal
//         open={show}
//         onClose={handleClose}
//         closeAfterTransition
//         aria-labelledby="add-existing-voter-modal"
//         dialogClassName="customAddExisting-modal-width"
//         sx={{ backdropFilter: "blur(4px)" }}
//       >
//         <Fade in={show}>
//           <Box
//             sx={{
//               position: "absolute",
//               top: "50%",
//               left: "50%",
//               transform: "translate(-50%, -50%)",
//               width: "70%",
//               // maxWidth: "1200px",
//               bgcolor: "background.paper",
//               borderRadius: 2,
//               boxShadow: 24,
//               p: 2,
//               maxHeight: "90vh",
//               display: "flex",
//               flexDirection: "column",
//             }}
//           >
//             {/* --- Header --- */}
//             <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
//               <Typography variant="h6" sx={{ fontWeight: 600 }}>
//                 Add Existing Voter
//               </Typography>
//               <IconButton onClick={handleClose}>
//                 <CloseIcon />
//               </IconButton>
//             </Box>

//             {/* --- Search Row --- */}
//             {/* <Box sx={{ display: "flex", alignItems: "center", mb: 1, flexWrap: "wrap", gap: 2 }}>
//             <FormControl size="small" sx={{ minWidth: 150 }}>
//               <InputLabel>Rows per page</InputLabel>
//               <Select value={rowsPerPage} label="Rows per page" onChange={handleChangeRowsPerPage}>
//                 {[5, 10, 25, 50].map((n) => (
//                   <MenuItem key={n} value={n}>
//                     {n}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//             <TextField label="Search" variant="outlined" size="small" value={searchText} onChange={(e) => setSearchText(e.target.value)} sx={{ width: 220 }} />
//             <Button variant="primary" onClick={handleSubmit}>
//               Submit
//             </Button>
//           </Box> */}
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 mb: 1,
//                 flexWrap: "wrap",
//                 justifyContent: "space-between", // pushes button to right
//               }}
//             >
//               {/* Left side: Rows per page + Search */}
//               <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                 <FormControl size="small" sx={{ minWidth: 150 }}>
//                   <InputLabel>Rows per page</InputLabel>
//                   <Select value={rowsPerPage} label="Rows per page" onChange={handleChangeRowsPerPage}>
//                     {[5, 10, 25, 50].map((n) => (
//                       <MenuItem key={n} value={n}>
//                         {n}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>

//                 <TextField label="Search" variant="outlined" size="small" value={searchText} onChange={(e) => setSearchText(e.target.value)} sx={{ width: 220 }} />
//                 <div className="village-Location-Card border rounded d-flex align-items-center gap-3 text-wrap">
//                   <span>
//                     <strong>Core</strong>
//                     {selectedVillage && `: ${selectedVillage}`}
//                   </span>

//                   {selectedLocality && (
//                     <span>
//                       <strong>Locality</strong>
//                       {selectedLocality && `: ${selectedLocality}`}
//                     </span>
//                   )}
//                 </div>
//                 <FormControlLabel
//                   control={
//                     <MuiCheckbox
//                       checked={fetchAllVillage}
//                       // onChange={(e) => setFetchAllVillage(e.target.checked)}
//                       size="small"
//                       color="success"
//                       onChange={(e) => {
//                         const checked = e.target.checked;
//                         setFetchAllVillage(checked);
//                         setSelectedRecords({}); // Reset every time
//                       }}
//                     />
//                   }
//                   label="All"
//                   sx={{ fontWeight: 600, color: fetchAllVillage ? "green" : "inherit" }}
//                 />
//               </Box>

//               {/* Right side: Submit button */}
//               <div className="px-4">
//                 <Button variant="primary" onClick={handleSubmit}>
//                   Submit
//                 </Button>
//               </div>
//             </Box>

//             {/* --- Table Section --- */}
//             <Box sx={{ flex: 1, overflow: "auto" }}>
//               <TableContainer component={Paper} variant="outlined">
//                 <Table sx={{ minWidth: 1200 }} aria-label="voter table">
//                   {/* <TableHead>
//                   <TableRow>
//                     <StyledTableCell align="center" padding="checkbox">
//                       <Checkbox color="primary" checked={isAllSelected} onChange={handleSelectAll} />
//                     </StyledTableCell>
//                     {columns.map((col) => (
//                       <StyledTableCell key={col.id} style={{ width: col.width }} sortDirection={orderBy === col.id ? order : false}>
//                         <TableSortLabel active={col.id} direction={orderBy === col.id ? order : "asc"} onClick={() => handleRequestSort(col.id)}>
//                           {col.label}
//                         </TableSortLabel>
//                       </StyledTableCell>
//                     ))}
//                     <StyledTableCell align="center">Handicap</StyledTableCell>
//                     <StyledTableCell align="center">Outside</StyledTableCell>
//                   </TableRow>
//                 </TableHead> */}
//                   <TableHead>
//                     <TableRow>
//                       {/* Select All Checkbox */}
//                       <StyledTableCell align="center" padding="checkbox">
//                         <Checkbox color="primary" checked={isAllSelected} onChange={handleSelectAll} />
//                       </StyledTableCell>

//                       {/* Existing Columns */}
//                       {columns.map((col) => (
//                         <StyledTableCell key={col.id} style={{ width: col.width }} sortDirection={orderBy === col.id ? order : false}>
//                           <TableSortLabel active={orderBy === col.id} direction={orderBy === col.id ? order : "asc"} onClick={() => handleRequestSort(col.id)}>
//                             {col.label}
//                           </TableSortLabel>
//                         </StyledTableCell>
//                       ))}

//                       <StyledTableCell align="center">
//                         <TableSortLabel direction="asc">Handicap</TableSortLabel>
//                       </StyledTableCell>
//                       <StyledTableCell align="center">
//                         <TableSortLabel direction="asc">Outside</TableSortLabel>
//                       </StyledTableCell>
//                     </TableRow>
//                   </TableHead>

//                   <TableBody>
//                     {isMemberFetching ? (
//                       <TableRow>
//                         <StyledTableCell colSpan={columns.length + 3} align="center">
//                           <TableShimmer theme="light" />
//                         </StyledTableCell>
//                       </TableRow>
//                     ) : currentPageData.length > 0 ? (
//                       currentPageData.map((row, index) => {
//                         const isChecked = Object.keys(selectedRecords).includes(String(row.VoterID));
//                         const selectedRecord = selectedRecords[row.VoterID] || {};
//                         return (
//                           <StyledTableRow key={row.VoterID}>
//                             <StyledTableCell align="center" padding="checkbox">
//                               <Checkbox color="primary" checked={isChecked} onChange={(e) => handleRowSelect(row.VoterID, row, e.target.checked)} />
//                             </StyledTableCell>

//                             {columns.map((col) => (
//                               <StyledTableCell key={col.id}>{row[col.id] || "-"}</StyledTableCell>
//                             ))}

//                             {/* ✅ New Handicap Checkbox */}
//                             <StyledTableCell align="center">
//                               <input
//                                 type="checkbox"
//                                 className="handicap-checkbox cursor-pointer"
//                                 disabled={!isChecked}
//                                 checked={!!selectedRecord.IsHandicap}
//                                 onChange={() => handleHandicapChange(row.VoterID)}
//                               />
//                             </StyledTableCell>

//                             {/* ✅ New Outside Checkbox */}
//                             <StyledTableCell align="center">
//                               <input
//                                 type="checkbox"
//                                 className="outside-checkbox cursor-pointer"
//                                 disabled={!isChecked}
//                                 checked={!!selectedRecord.IsOutSide}
//                                 onChange={() => handleOutsideChange(row.VoterID)}
//                               />
//                             </StyledTableCell>
//                           </StyledTableRow>
//                         );
//                       })
//                     ) : (
//                       <TableRow>
//                         <StyledTableCell colSpan={columns.length + 3} align="center">
//                           No records found
//                         </StyledTableCell>
//                       </TableRow>
//                     )}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             </Box>

//             {/* --- Pagination --- */}
//             <TablePagination component="div" count={filteredData.length} rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage} rowsPerPageOptions={[]} />
//           </Box>
//         </Fade>
//       </Modal>
//       {inserting && <Loader />}
//     </>
//   );
// };

// export default AddExistingVoter;

import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Checkbox,
  Fade,
  FormControlLabel,
  IconButton,
  Modal,
  Checkbox as MuiCheckbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Cookies from "js-cookie";
import * as React from "react";
import { Button } from "react-bootstrap";
import { useMemberWithPagination } from "../../API_Master/FetchAPI";
import { useSetExistingVoter } from "../../API_Master/MutateAPI";
import Loader from "../../CommonComponents/Loader";
import PageCountSelect from "../../CommonComponents/PageCountSelect";
import PageEntries from "../../CommonComponents/PageEntries";
import PaginationButtons from "../../CommonComponents/PaginationButtons";
import TableShimmer from "../../Components/TableShimmer";
import { notifyError, notifySuccess } from "../../MethodMaster/JSXComponentMothod";

// --- Styled Components ---
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": { backgroundColor: theme.palette.action.hover },
  "&:last-child td, &:last-child th": { border: 0 },
  "&:hover": { backgroundColor: "#E3F2FD" },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${theme?.tableCellClasses?.head}`]: {
    backgroundColor: "#D6E4FF",
    color: "#1A237E",
    fontWeight: 600,
    fontSize: 14,
  },
  [`&.${theme?.tableCellClasses?.body}`]: {
    fontSize: 13,
  },
}));

const AddExistingVoter = ({ show, handleClose, selectedRecords, setSelectedRecords, selectedVillage, selectedLocality, familyHeadMasterID, refetchMemberList }) => {
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [currentPage, setCurrentPage] = React.useState(0);
  const [searchText, setSearchText] = React.useState("");
  const [orderBy, setOrderBy] = React.useState("");
  const [order, setOrder] = React.useState("asc");
  const [fetchAllVillage, setFetchAllVillage] = React.useState(false);

  const { mutate: addExistingVoter, isPending: inserting } = useSetExistingVoter();

  const { data, fetchNextPage, hasNextPage, isFetching, isLoading, isError } = useMemberWithPagination(
    show,
    selectedVillage,
    !fetchAllVillage ? selectedLocality : "",
    rowsPerPage,
    searchText,
    false,
  );

  const pages = data?.pages || [];
  const totalCount = data?.pages[0]?.TotalCount || 0;
  const start = currentPage * rowsPerPage + 1;
  const end = Math.min(start + (pages[currentPage]?.data?.length || 0) - 1, totalCount);

  const currentPageData = pages[currentPage]?.data || [];

  // Reset page when filters/search change
  React.useEffect(() => {
    setCurrentPage(0);
  }, [searchText, rowsPerPage, fetchAllVillage, selectedVillage, selectedLocality]);

  // Sort only the currently loaded page (same as before)
  const displayData = React.useMemo(() => {
    if (!orderBy) return currentPageData;
    return [...currentPageData].sort((a, b) => {
      const aVal = a[orderBy] || "";
      const bVal = b[orderBy] || "";
      return order === "asc" ? String(aVal).localeCompare(String(bVal)) : String(bVal).localeCompare(String(aVal));
    });
  }, [currentPageData, orderBy, order]);

  // --- Selection logic ---
  const isAllSelected = displayData.length > 0 && displayData.every((r) => Object.keys(selectedRecords).includes(String(r.VoterID)));

  const handleRowSelect = (voterId, record, checked) => {
    setSelectedRecords((prev) => {
      const updated = { ...prev };
      if (checked) updated[voterId] = { ...record };
      else delete updated[voterId];
      return updated;
    });
  };

  const handleSelectAll = () => {
    setSelectedRecords((prev) => {
      const updated = { ...prev };
      if (isAllSelected) {
        displayData.forEach((r) => delete updated[r.VoterID]);
      } else {
        displayData.forEach((r) => (updated[r.VoterID] = { ...r }));
      }
      return updated;
    });
  };

  const handleHandicapChange = (voterId) => {
    setSelectedRecords((prev) => {
      if (!prev[voterId]) return prev;
      return {
        ...prev,
        [voterId]: { ...prev[voterId], IsHandicap: !prev[voterId].IsHandicap },
      };
    });
  };

  const handleOutsideChange = (voterId) => {
    setSelectedRecords((prev) => {
      if (!prev[voterId]) return prev;
      return {
        ...prev,
        [voterId]: { ...prev[voterId], IsOutSide: !prev[voterId].IsOutSide },
      };
    });
  };

  // ─────────────────────────────────────────────────────────
  // Same handleRowsChange + goToPage as ViewMemberList
  // ─────────────────────────────────────────────────────────
  const handleRowsChange = (e) => {
    const limit = parseInt(e.target?.value);
    setRowsPerPage(limit);
    setCurrentPage(0);
  };

  const goToPage = async (index) => {
    if (pages[index]) {
      setCurrentPage(index);
    } else if (hasNextPage) {
      await fetchNextPage();
      setCurrentPage(index);
    }
  };

  const handleRequestSort = (columnId) => {
    const isAsc = orderBy === columnId && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(columnId);
  };

  const columns = [
    { id: "FullNameEnglish", label: "Full Name", width: "15%" },
    { id: "MobileNo", label: "Mobile No.", width: "10%" },
    { id: "IDCardNo", label: "ID Card No.", width: "10%" },
    { id: "Age", label: "Age", width: "5%" },
    { id: "HouseNoEnglish", label: "House No.", width: "10%" },
  ];

  const handleSubmit = () => {
    if (Object.keys(selectedRecords)?.length === 0) {
      notifyError("Please Select at least on Voter");
      return;
    }
    const familyDetailData = Object.keys(selectedRecords)?.map((id) => selectedRecords[id]);

    const payload = {
      UserID: Cookies.get("Mukesh_Patel_UserID") || "",
      FamilyHeadMasterID: familyHeadMasterID,
      FamilyDetail: familyDetailData,
      CreatedByUserID: Cookies.get("Mukesh_Patel_UserID") || "",
    };

    addExistingVoter(payload, {
      onSuccess: (res) => {
        if (res?.status === true) {
          notifySuccess("Successfully Inserted", false);
          handleClose();
          refetchMemberList();
        } else {
          notifyError(res?.message ? res.message : "Data Not Inserted", false);
        }
      },
      onError: (err) => {
        const errorMessage = err?.message || "Failed to assign system";
        console.error(err);
        notifyError(errorMessage || "Something went wrong", false);
      },
    });
  };

  return (
    <>
      <Modal
        open={show}
        onClose={handleClose}
        closeAfterTransition
        aria-labelledby="add-existing-voter-modal"
        dialogClassName="customAddExisting-modal-width"
        sx={{ backdropFilter: "blur(4px)" }}
      >
        <Fade in={show}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "70%",
              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 24,
              p: 2,
              maxHeight: "90vh",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* --- Header --- */}
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Add Existing Voter
              </Typography>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Box>

            {/* --- Toolbar --- */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                mb: 1,
                flexWrap: "wrap",
                justifyContent: "space-between",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                {/* Same rows-per-page selector as other pages */}
                <PageCountSelect rowsPerPage={rowsPerPage} handleRowsChange={handleRowsChange} />

                <TextField label="Search" variant="outlined" size="small" value={searchText} onChange={(e) => setSearchText(e.target.value)} sx={{ width: 220 }} />

                <div className="village-Location-Card border rounded d-flex align-items-center gap-3 text-wrap">
                  <span>
                    <strong>Core</strong>
                    {selectedVillage && `: ${selectedVillage}`}
                  </span>

                  {selectedLocality && (
                    <span>
                      <strong>Locality</strong>
                      {selectedLocality && `: ${selectedLocality}`}
                    </span>
                  )}
                </div>

                <FormControlLabel
                  control={
                    <MuiCheckbox
                      checked={fetchAllVillage}
                      size="small"
                      color="success"
                      onChange={(e) => {
                        const checked = e.target.checked;
                        setFetchAllVillage(checked);
                        setSelectedRecords({});
                      }}
                    />
                  }
                  label="All"
                  sx={{ fontWeight: 600, color: fetchAllVillage ? "green" : "inherit" }}
                />
              </Box>

              <div className="px-4">
                <Button variant="primary" onClick={handleSubmit}>
                  Submit
                </Button>
              </div>
            </Box>

            {/* --- Table --- */}
            <Box sx={{ flex: 1, overflow: "auto" }}>
              <TableContainer component={Paper} variant="outlined">
                <Table sx={{ minWidth: 1200 }} aria-label="voter table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell align="center" padding="checkbox">
                        <Checkbox color="primary" checked={isAllSelected} onChange={handleSelectAll} />
                      </StyledTableCell>

                      {columns.map((col) => (
                        <StyledTableCell key={col.id} style={{ width: col.width }} sortDirection={orderBy === col.id ? order : false}>
                          <TableSortLabel active={orderBy === col.id} direction={orderBy === col.id ? order : "asc"} onClick={() => handleRequestSort(col.id)}>
                            {col.label}
                          </TableSortLabel>
                        </StyledTableCell>
                      ))}

                      <StyledTableCell align="center">
                        <TableSortLabel direction="asc">Handicap</TableSortLabel>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <TableSortLabel direction="asc">Outside</TableSortLabel>
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {isLoading || isError || isFetching ? (
                      <TableRow>
                        <StyledTableCell colSpan={columns.length + 3} align="center">
                          <TableShimmer theme="light" />
                        </StyledTableCell>
                      </TableRow>
                    ) : displayData.length > 0 ? (
                      displayData.map((row) => {
                        const isChecked = Object.keys(selectedRecords).includes(String(row.VoterID));
                        const selectedRecord = selectedRecords[row.VoterID] || {};
                        return (
                          <StyledTableRow key={row.VoterID}>
                            <StyledTableCell align="center" padding="checkbox">
                              <Checkbox color="primary" checked={isChecked} onChange={(e) => handleRowSelect(row.VoterID, row, e.target.checked)} />
                            </StyledTableCell>

                            {columns.map((col) => (
                              <StyledTableCell key={col.id}>{row[col.id] || "-"}</StyledTableCell>
                            ))}

                            <StyledTableCell align="center">
                              <input
                                type="checkbox"
                                className="handicap-checkbox cursor-pointer"
                                disabled={!isChecked}
                                checked={!!selectedRecord.IsHandicap}
                                onChange={() => handleHandicapChange(row.VoterID)}
                              />
                            </StyledTableCell>

                            <StyledTableCell align="center">
                              <input
                                type="checkbox"
                                className="outside-checkbox cursor-pointer"
                                disabled={!isChecked}
                                checked={!!selectedRecord.IsOutSide}
                                onChange={() => handleOutsideChange(row.VoterID)}
                              />
                            </StyledTableCell>
                          </StyledTableRow>
                        );
                      })
                    ) : (
                      <TableRow>
                        <StyledTableCell colSpan={columns.length + 3} align="center">
                          No records found
                        </StyledTableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

            {/* --- Pagination (same pattern as other pages) --- */}
            <div className="row mx-3 justify-content-between mt-2">
              <PageEntries start={start} end={end} totalCount={totalCount} />
              <PaginationButtons
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                goToPage={goToPage}
                pages={pages}
                hasNextPage={hasNextPage}
                fetchNextPage={fetchNextPage}
              />
            </div>
          </Box>
        </Fade>
      </Modal>

      {inserting && <Loader />}
    </>
  );
};

export default AddExistingVoter;
